import { TFunction } from 'i18next';
import React from 'react';
import { Button, Typography } from '../../../UIKit';
import RandomIllustration from '../../../Components/Illustrations/RandomIllustration';
import { makeStyles } from '~/UIKit/Style';

type EmailSentSuccessProps = {
  t: TFunction;
  backToLogin: () => void;
};

const useStyles = makeStyles({
  container: {
    maxWidth: 360,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  illustration: {
    width: '90px',
    height: '100px',
    margin: '30px 0',
  },
  title: {
    fontWeight: 'bold',
  },
  body: {
    marginBottom: 30,
  },
  button: {
    marginBottom: 30,
  },
});

const EmailSentSuccess = ({ t, backToLogin }: EmailSentSuccessProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Typography className={classes.title} data-testid="emailSuccessTitle" variant="h4">
        {t('email.sent')}
      </Typography>
      <div className={classes.illustration}>
        <RandomIllustration />
      </div>
      <Typography className={classes.body} variant="body2">
        {t('app.recoverPassword.checkInbox')}
      </Typography>
      <Button
        className={classes.button}
        color="primary"
        fullWidth
        onClick={backToLogin}
        variant="contained"
      >
        {t('app.backToLogin')}
      </Button>
    </div>
  );
};

export default EmailSentSuccess;
